import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const ConvertDictionaryRowButton = ({ onClick, disabled }) => {
  const intl = useIntl();
  return (
    <Button
      className="aridhia-row-convert-button"
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      compact
      basic
      icon
      data-tooltip={intl.formatMessage({ id: 'actions.convert.dictionary.row' })}
      data-position="bottom right"
    >
      <Icon
        name="arrow alternate circle right"
        className="primary"
        alt={intl.formatMessage({ id: 'actions.convert.dictionary.row' })}
      />
    </Button>
  );
};

export default ConvertDictionaryRowButton;
